import { isEqualWith } from 'lodash-es';
import { isValidElement } from 'react';
// Element props are compared with the same customizer so leaf rules (e.g. ignoring functions) hold inside elements too.
function elementAware(customizer) {
    return function compare(a, b) {
        if (isValidElement(a) && isValidElement(b)) {
            return a.type === b.type && a.key === b.key && isEqualWith(a.props, b.props, compare);
        }
        if (isValidElement(a) || isValidElement(b))
            return false;
        return customizer(a, b);
    };
}
const compareElements = elementAware(() => undefined);
const compareElementsIgnoringFunctions = elementAware((a, b) => typeof a === 'function' && typeof b === 'function' ? true : undefined);
/** Deep equality that compares React elements by type, key and props (ref ignored) instead of walking their owner fiber. */
export function isDeepEqual(a, b) {
    return isEqualWith(a, b, compareElements);
}
/** `isDeepEqual` that treats any two functions as equal, for values whose inline callbacks are recreated on every publish. */
export function isDeepEqualIgnoringFunctions(a, b) {
    return isEqualWith(a, b, compareElementsIgnoringFunctions);
}
